/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
import {
  FEATURE_FLAGS_NAMES,
  MEDIAN_METRICS,
  metricNames
} from '@linearb/linjs-common';
import { Grid } from '@material-ui/core';
import { API_GATEWAY_URI } from 'common/constants/api-urls';
import {
  LOCAL_STORAGE_KEYS,
  SEARCH_DATE_FORMAT,
  SESSION_STORAGE_KEYS,
  TEAM_TYPES,
  TRACKING,
  VIEW_PATH_KEYS
} from 'common/constants/constants';
import {
  getMetricsV3,
  getTeamMetricsV3,
  getMappedV3Data,
  getDashboardMetricsV3,
  convertMetricsNameToV3
} from 'common/services/metrics.service';
import { deactivateNotification } from 'common/services/notifications.service';
import { getTeamSettings } from 'common/services/settings.service';
import { getToken } from 'common/services/token.service';
import * as TrackingService from 'common/services/tracking.service';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { getDefaultFormatter } from 'common/utils/time.utils';
import { checkIfIterationIsTooLong, omitFromQs } from 'common/utils/utils';
import { mapCycleTimeStatisticsToPipelineMilestones } from 'components/DeliveryPipeline';
import NotConnectedState from 'components/NotConnectedState';
import TrialBar from 'components/TrialBar';
import { Flex, Margin, Page } from 'components/base/layout-components';
import computerDude from 'images/characters/computer-dude.svg';
import groupDashboardPlaceholderImg from 'images/group-dashboard-placeholder.jpg';
import _ from 'lodash';
import QueryString from 'query-string';
import { useEffect, useMemo } from 'react';
import { useBeforeunload } from 'react-beforeunload';
import { useSelector } from 'react-redux';
import { isSelectedTeamParentSelector } from 'state/selectors/teams';
import { isIterationsPeriodKeySelectedSelector } from 'state/selectors/ui-state';
import useMetricsCalculationConfig from '../../hooks/useMetricsCalculationConfig';

import AllTeamsDashboard from './AllTeamsDashboard';
import { StyledBackground } from './Dashboard.style';
import GroupDashboard from './GroupDashboard/GroupDashboard';
import TeamDashboardPreviousIteration from './TeamDashboardPreviousIteration';
import NoDataDashboard from './components/NoDataDashboard';
import { PRMergedTooltip } from './components/PRMergedTooltip';
import PulseDashboardBar from './components/PulseDashboardBar';
import {
  DASHBOARD_DEBOUNCE_PRIORITY,
  DEFAULT_REQUESTED_TEAM_METRICS,
  LAST_5_ITERATIONS_METRICS,
  RELEASES_DEFAULT_SETTINGS,
  TEAM_RETROSPECT_METRICS,
  cycleTimeGridSize
} from './dashboard.consts';
import {
  compute5IterationsData,
  loadTeamNotifications,
  toggleTeamSlackModal
} from './dashboard.service';
import generateMetricsArray from './helpers/generateMetricsArray';
import { loadOrgTrendData } from './helpers/loadOrganizationData';
import { useDashboardState } from './hooks/useDashboardState';
import { calcWorkBreakDownData, getTimeRangesByGranularity } from './util';
import { useDashboardSettings } from './hooks/useDashboardSettings';
import { useDashboardEffects } from './hooks/useDashboardEffects';
import { useTrendData } from './hooks/useTrendData';
import { useHistory } from 'react-router';
import { isSelectedIterationByDates } from 'state/selectors/helpers';
import { useDebounceCallback } from '@react-hook/debounce';
import AllContributorsDoraDashboard from './doraV2/AllContributorsDoraDashboard';
import useDoraFeatureFlags from '../../hooks/useDoraFeatureFlags';
import TeamDashboardCurrentIterationNew from './TeamDashboardCurrentIterationNew';
import { PERIODS } from 'components/PeriodPicker/periods/constants';
import useToast from 'components/hooks/useToast';
import useSettingsService from 'components/hooks/useSettingsService';
import useBenchmarkOrgSizeConfig from 'views/root/views/home/hooks/useBenchmarkOrgSizeConfig';
import { getIsGitScopeByKey } from 'components/TeamGitScopeBanner/utils';
import { getDurationLevels } from '@linearb/linui-utils';

const Dashboard = props => {
  const {
    slackSensorAuhorization,
    // getCommitStats,
    isVPMode,
    selectedTeam,
    DateSelectionChanged,
    datesFromTheBeginningOfPrevIter,
    current5Iterations,
    isFinishedOnBoarding,
    numOfDaysInSelectedIteration,
    numOfDaysInLatestIteration,
    account,
    patchAccount,
    isRetrospect,
    toggleModal,
    uiState,
    currentIteration,
    currentTeams,
    toggleSnackBar,
    organization,
    latestIteration,
    isTeamLicense,
    isProcessingRepos,
    hasNoData,
    isBlurred,
    teamPMEntitiesIds,
    contributors,
    isLoadingIterations,
    isDefaultIterationTooLong,
    gitScopeToggle
  } = props;
  const { dates, selectedTeamId } = uiState;
  const history = useHistory();
  const toast = useToast();
  const {
    isShowTeamOfTeamsDashboard,
    isTeamPMConfigurationEnabled,
    shouldHidePersonalInformationDashboard,
    isNewTeamDashboardPastIterationEnabled
  } = useDashboardSettings();
  const localStorageAccessor = BrowserStorageAccessor().local;
  const isAllTeamsGroup = selectedTeam?.type === TEAM_TYPES.ALL_TEAMS;
  const isSelectedTeamParent = useSelector(isSelectedTeamParentSelector);
  const isGroup = isSelectedTeamParent || isAllTeamsGroup;
  const isIterationsPeriodKeySelected = useSelector(
    isIterationsPeriodKeySelectedSelector
  );
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isPreventTooLongIterationsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isPreventTooLongIterationsEnabled
  });
  const isLatestIterationTooLong = checkIfIterationIsTooLong({
    iteration: latestIteration,
    isPreventTooLongIterationsEnabled
  });
  const issuesProps = useMemo(
    () => ({
      contributors,
      // If selected period - last iteration; else - selected iteration
      currentIteration:
        isIterationsPeriodKeySelected && !isRetrospect
          ? currentIteration
          : isLatestIterationTooLong
          ? {
              // send past 30 days to graphql
              end_date: PERIODS.PAST_30_DAYS.before.format(SEARCH_DATE_FORMAT),
              start_date: PERIODS.PAST_30_DAYS.after.format(SEARCH_DATE_FORMAT),
              type: 'weekly'
            }
          : latestIteration,
      currentTeams,
      history,
      selectedTeam
    }),
    [isIterationsPeriodKeySelected, selectedTeam, currentIteration]
  );
  // If selected period - numOfDays of last iteration; else - numOfDays of selected period
  const numOfDaysInIteration = isIterationsPeriodKeySelected
    ? numOfDaysInSelectedIteration
    : numOfDaysInLatestIteration;
  const metricsCalculationConfig = useMetricsCalculationConfig();
  const { benchmarkOrgSize } = useBenchmarkOrgSizeConfig();
  const {
    cycleTimeStatistics,
    setCycleTimeStatistics,
    notifications,
    setNotifications,
    isNotificationsLoading,
    setIsNotificationsLoading,
    teamMetrics,
    setTeamMetrics,
    teamSlackSettings,
    setTeamSlackSettings,
    teamRetrospectData,
    setTeamRetrospectData,
    contributorsMetrics,
    setContributorsMetrics,
    contributorsOrder,
    setContributorsOrder,
    organizationMetrics,
    setOrganizationMetrics,
    organizationCodeChanges,
    setOrganizationCodeChanges,
    releases,
    setReleases,
    teamWorkBreakdownData,
    setTeamWorkBreakdownData,
    orgWorkBreakdownData,
    setOrgWorkBreakdownData,
    prMergedPerIteration,
    setPrMergedPerIteration,
    prOpenRate,
    setPrOpenRate,
    organizationDeploymentFrequency,
    setOrganizationDeploymentFrequency,
    noReleasesInIterations,
    setNoReleasesInIterations,
    closedPulseTopBar,
    setClosedPulseTopBar,
    contributorsBars,
    setContributorsBars
  } = useDashboardState();

  useDashboardEffects(
    props,
    contributorsOrder,
    setContributorsMetrics,
    setIsNotificationsLoading,
    gitScopeToggle
  );

  const {
    cycleTimeTrendData,
    deploymentFreqData,
    reviewsTrendData,
    setCycleTimeTrendData,
    setWorkBreakdownTrendData,
    workBreakdownTrendData,
    isLodingCycleTimeData
  } = useTrendData(props, setNoReleasesInIterations, gitScopeToggle);

  const { isAllControbutorsTeamSelected } = useDoraFeatureFlags();

  const saveLastViewNotificationTime = () => {
    if (selectedTeamId && !isRetrospect) {
      localStorageAccessor.set(
        LOCAL_STORAGE_KEYS.LAST_VIEW_NOTIFICATIONS(selectedTeamId),
        new Date()
      );
    }
  };

  useEffect(() => {
    if (isDefaultIterationTooLong) {
      toast({
        autoHideDuration: 5000,
        message:
          'Iterations cannot be longer than 90 days. We have selected the last 30 days. ',
        variant: 'info'
      });
    }
  }, [isDefaultIterationTooLong]);

  useBeforeunload(saveLastViewNotificationTime);

  const loadOrganizationData = async (
    current5Iterations,
    dates,
    datesFromTheBeginningOfPrevIter,
    numOfDaysInIteration
  ) => {
    const { metricsCalculationStrategy } = metricsCalculationConfig;

    const last5IterationsTimeRanges = _(current5Iterations)
      .map(({ start_date, end_date }) => ({
        after: start_date,
        before: end_date
      }))
      .value();

    const promiseSet = [];

    promiseSet.push(
      getDashboardMetricsV3({
        time_ranges: [{ after: dates.from, before: dates.to }],
        requested_metrics: convertMetricsNameToV3(
          DEFAULT_REQUESTED_TEAM_METRICS,
          metricsCalculationStrategy
        )
      })
    );

    promiseSet.push(
      getMetricsV3({
        requested_metrics: convertMetricsNameToV3(
          LAST_5_ITERATIONS_METRICS,
          metricsCalculationStrategy
        ),
        roll_up: 'custom',
        group_by: 'organization',
        time_ranges: last5IterationsTimeRanges
      })
    );

    try {
      const result = await Promise.all(promiseSet);
      const v3DataResult = _.get(result[0], '[0].data[0]', {});
      const mappedV3Data = getMappedV3Data({ v3DataResult });

      const cycleTimeData = _.pick(mappedV3Data, MEDIAN_METRICS);
      setCycleTimeStatistics(cycleTimeData);
      setOrganizationMetrics(mappedV3Data);
      setOrgWorkBreakdownData(
        calcWorkBreakDownData({
          newWork: mappedV3Data[metricNames.NEW_WORK],
          refactor: mappedV3Data[metricNames.REFACTOR],
          rework: mappedV3Data[metricNames.REWORK],
          total: mappedV3Data[metricNames.COMMIT_CODE_CHANGES]
        })
      );

      const v3Last5IterationsResponse = result[1];

      const flattenResponse = _.get(v3Last5IterationsResponse, '[0].data', []);
      const getIterationStructure = metricName => {
        return _(current5Iterations)
          .map(({ start_date, end_date, name }, idx) => {
            return {
              start: start_date,
              end: end_date,
              value: Math.round(
                _.get(flattenResponse, `[${idx}]['${metricName}']`, null)
              ),
              // if selected period - return first iteration; else - return iteration matching start and end date
              isSelected: isIterationsPeriodKeySelected
                ? isSelectedIterationByDates({
                    uiStateDates: uiState?.dates,
                    iterationStartDate: start_date,
                    iterationEndDate: end_date
                  })
                : idx === 0,
              name
            };
          })
          .orderBy('end')
          .value();
      };
      const fiveIterationsPrsMergedCount = compute5IterationsData(
        getIterationStructure(metricNames.PR_MERGED),
        'PRS MERGED'
      );
      setPrMergedPerIteration({
        ...fiveIterationsPrsMergedCount,
        goTo: ({ history }) => {
          const searchParams = {
            order_by: 'updated_at,desc',
            merged: `${currentIteration.start_date},${currentIteration.end_date}`
          };

          history.push({
            pathname: '/activity/pull-requests',
            search: `?${QueryString.stringify(searchParams)}`
          });
        }
      });
      const fiveIterationsPrNewCount = compute5IterationsData(
        getIterationStructure(metricNames.PR_NEW),
        'PR NEW'
      );
      const selectedIterationPrNewCount = (
        fiveIterationsPrNewCount.iterations || []
      ).find(({ isSelected }) => isSelected);
      const prNewCount = _.get(selectedIterationPrNewCount, 'value', null);
      setPrOpenRate(((prNewCount || 0) / numOfDaysInIteration).toFixed(1));

      setOrganizationCodeChanges(
        compute5IterationsData(
          getIterationStructure(metricNames.COMMIT_CODE_CHANGES),
          'CODE CHANGES'
        )
      );
      setContributorsBars(
        compute5IterationsData(
          getIterationStructure(metricNames.ACTIVE_CONTRIBUTORS),
          'Contributors'
        )
      );
      const fiveIterationsReleasesCount = compute5IterationsData(
        getIterationStructure(metricNames.RELEASES_COUNT),
        'RELEASES'
      );
      setReleases({
        ...RELEASES_DEFAULT_SETTINGS,
        ...fiveIterationsReleasesCount
      });
      const selectedIterationReleaseCount = (
        fiveIterationsReleasesCount.iterations || []
      ).find(({ isSelected }) => isSelected);
      const releaseCount = _.get(selectedIterationReleaseCount, 'value', null);
      setNoReleasesInIterations(
        flattenResponse.every(
          val => _.get(val, metricNames.RELEASES_COUNT, 0) === 0
        )
      );
      setOrganizationDeploymentFrequency(
        !noReleasesInIterations &&
          _.isNumber(releaseCount) &&
          numOfDaysInIteration > 0
          ? (releaseCount / numOfDaysInIteration).toFixed(1)
          : '-'
      );

      const { xData, yCycleTimeData, yWorkBreakDownData } =
        await loadOrgTrendData(
          current5Iterations,
          metricsCalculationConfig,
          organization
        );

      setCycleTimeTrendData({ x: xData, y: yCycleTimeData });
      setWorkBreakdownTrendData({ x: xData, y: yWorkBreakDownData });
    } catch (exp) {
      setCycleTimeStatistics({});
      setOrganizationMetrics({});
    }
  };

  const onRemoveNotificationClick = async notificationId => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.DASHBOARD,
      page_tab: TRACKING.PAGE_TABS.NOTIFICATIONS,
      click_type: TRACKING.CLICK.DISMISS
    });
    await deactivateNotification(notificationId);
    await loadTeamNotifications({
      teamId: selectedTeamId,
      withLoading: false,
      setIsNotificationsLoading,
      setNotifications,
      history,
      localStorageAccessor
    });
  };

  const loadTeamData = async (
    teamId,
    dates,
    metricsCalculationConfig = {},
    gitScopeToggle = null
  ) => {
    // fetch cycle time and contributors table header data

    const time_ranges = [{ after: dates.from, before: dates.to }];
    const { metricsCalculationStrategy } = metricsCalculationConfig;

    const teamMetrics = await getTeamMetricsV3({
      time_ranges,
      teamId,
      requested_metrics: convertMetricsNameToV3(
        DEFAULT_REQUESTED_TEAM_METRICS,
        metricsCalculationStrategy
      ),
      ...(gitScopeToggle !== null
        ? {
            team_git_scope_disabled: !getIsGitScopeByKey(
              gitScopeToggle,
              VIEW_PATH_KEYS.DASHBOARD
            )
          }
        : {})
    });

    try {
      const v3DataResult = _.get(teamMetrics, '[0].data[0]', {});
      const metricsItems = getMappedV3Data({ v3DataResult });
      setTeamMetrics(metricsItems);

      const {
        [metricNames.NEW_WORK]: newWork,
        [metricNames.REWORK]: rework,
        [metricNames.REFACTOR]: refactor,
        [metricNames.COMMIT_CODE_CHANGES]: changes
      } = metricsItems;

      setTeamWorkBreakdownData(
        calcWorkBreakDownData({ newWork, rework, refactor, changes })
      );
    } catch (exp) {}

    if (isRetrospect && (!isDefaultIterationTooLong || currentIteration?.id)) {
      const { start_date, end_date } = currentIteration || {};
      const ranges = getTimeRangesByGranularity(start_date, end_date);

      const v3TeamRetrospectMetrics = TEAM_RETROSPECT_METRICS;

      try {
        await loadTeamNotifications({
          teamId,
          withLoading: true,
          setIsNotificationsLoading,
          setNotifications,
          history,
          localStorageAccessor
        });
        const joinedData = await getTeamMetricsV3({
          time_ranges: ranges,
          teamId,
          requested_metrics: convertMetricsNameToV3(
            v3TeamRetrospectMetrics,
            metricsCalculationStrategy
          ),
          ...(gitScopeToggle !== null
            ? {
                team_git_scope_disabled: !getIsGitScopeByKey(
                  gitScopeToggle,
                  VIEW_PATH_KEYS.DASHBOARD
                )
              }
            : {})
        });

        const reviewDepth = _.get(joinedData, '[0].data').reduce(
          (acc, cur, index) => {
            const {
              [metricNames.REVIEWS]: reviews,
              [metricNames.REVIEW_DEPTH]: reviewDepth
            } = cur;
            acc[ranges[index].after] = [reviews || 0, reviewDepth || 0];
            return acc;
          },
          {}
        );
        const deploymentFrequency = _.get(joinedData, '[0].data').reduce(
          (acc, cur, index) => {
            const { [metricNames.RELEASES_COUNT]: releases = 0 } = cur;
            acc[ranges[index].after] = [releases];
            return acc;
          },
          {}
        );
        setTeamRetrospectData({ reviewDepth, deploymentFrequency });
      } catch (exp) {
        setTeamRetrospectData({ reviewDepth: {}, deploymentFrequency: {} });
      }
    } else {
      getTeamSettings(selectedTeamId).then(settings =>
        setTeamSlackSettings({
          channel: _.get(
            settings,
            'notifications.teamSlackChannel.value',
            null
          ),
          isEnabled: _.get(
            settings,
            'notifications.teamIsNotificationsEnabled.value',
            false
          )
        })
      );
      const sessionStorageAccessor = BrowserStorageAccessor().session;
      const predirectTeamId = sessionStorageAccessor.get(
        SESSION_STORAGE_KEYS.SLACK_REDIRECT_TEAM_ID
      );
      if (predirectTeamId) {
        if (slackSensorAuhorization) {
          toggleTeamSlackModal({
            account,
            toggleSnackBar,
            patchAccount,
            setTeamSlackSettings,
            toggleModal,
            selectedTeamId,
            selectedTeam
          });
        }
        sessionStorageAccessor.remove(
          SESSION_STORAGE_KEYS.SLACK_REDIRECT_TEAM_ID
        );
      }
      await loadTeamNotifications({
        teamId,
        withLoading: true,
        setIsNotificationsLoading,
        setNotifications,
        history,
        localStorageAccessor
      });
      TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
        page: TRACKING.PAGES.DASHBOARD,
        page_tab: TRACKING.PAGE_TABS.NOTIFICATIONS,
        num_of_not: notifications.length
      });
    }
  };

  const debounceLoadTeamData = useDebounceCallback(
    loadTeamData,
    DASHBOARD_DEBOUNCE_PRIORITY.HIGH
  );
  const debounceLoadOrgData = useDebounceCallback(
    loadOrganizationData,
    DASHBOARD_DEBOUNCE_PRIORITY.HIGH
  );

  useEffect(() => {
    if (
      !isVPMode &&
      selectedTeam &&
      isFinishedOnBoarding &&
      !isLoadingIterations &&
      !isGroup
    ) {
      debounceLoadTeamData(
        selectedTeamId,
        dates,
        metricsCalculationConfig,
        gitScopeToggle
      );
    }

    if (isVPMode) {
      debounceLoadOrgData(
        current5Iterations,
        dates,
        datesFromTheBeginningOfPrevIter,
        numOfDaysInIteration
      );
    }
    return saveLastViewNotificationTime;
  }, [
    dates,
    isFinishedOnBoarding,
    isProcessingRepos,
    selectedTeamId,
    isLoadingIterations,
    gitScopeToggle
  ]);

  useEffect(() => {
    const { postSlackReAuth, existingSlackWs } = QueryString.parse(
      history.location.search
    );
    if (postSlackReAuth && selectedTeam) {
      omitFromQs('postSlackReAuth');
      if (!existingSlackWs) {
        toggleTeamSlackModal({
          firstUser: true,
          account,
          toggleSnackBar,
          patchAccount,
          setTeamSlackSettings,
          toggleModal,
          selectedTeamId,
          selectedTeam
        });
      }
    }
  }, [selectedTeam]);

  if (!currentIteration) {
    return null;
  }

  const handleOnSlackConnectClick = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.DASHBOARD,
      click_type: TRACKING.CLICK.SLACK_CONNECT
    });
    if (slackSensorAuhorization) {
      toggleTeamSlackModal({
        account,
        toggleSnackBar,
        patchAccount,
        setTeamSlackSettings,
        toggleModal,
        selectedTeamId,
        selectedTeam
      });
    } else {
      BrowserStorageAccessor().session.set(
        SESSION_STORAGE_KEYS.SLACK_REDIRECT_TEAM_ID,
        selectedTeamId
      );
      const url = `${API_GATEWAY_URI}/api/v1/rest/auth/grant/slack`;
      const token = getToken();
      window.location.href = `${url}?token=${token}`;
    }
  };

  const { [metricNames.REVIEW_DEPTH]: reviewDepth } = organizationMetrics;

  const metrics = generateMetricsArray(
    organizationCodeChanges,
    numOfDaysInIteration,
    organizationDeploymentFrequency,
    prOpenRate,
    reviewDepth
  );

  const timeToProd = isVPMode
    ? cycleTimeStatistics[metricNames.TIME_TO_PROD]
    : teamMetrics[metricNames.TIME_TO_PROD];
  const tooltips = {
    pr_merged:
      !_.isNumber(timeToProd) && noReleasesInIterations && !isBlurred
        ? PRMergedTooltip
        : null
  };
  const pipelineMilestones = mapCycleTimeStatisticsToPipelineMilestones(
    isVPMode ? cycleTimeStatistics : teamMetrics,
    { ...tooltips },
    metricsCalculationConfig,
    benchmarkOrgSize
  );
  const activities = [
    organizationCodeChanges,
    prMergedPerIteration,
    releases,
    contributorsBars
  ];

  const totalCycleTimeInMinutes =
    _.sum(
      pipelineMilestones
        .map(({ rawValue }) => rawValue)
        .filter(value => !!value)
    ) || 0;

  const cycleTimeAverage = getDurationLevels({
    minutes: totalCycleTimeInMinutes,
    ignoreZeros: true,
    format: getDefaultFormatter({
      minutes: totalCycleTimeInMinutes,
      daysUnit: ' days',
      hoursUnit: ' hours',
      minutesUnit: ' minutes',
      yearsUnit: ' years'
    }),
    joiner: ' '
  });

  const shouldShowPulseTopBar =
    !closedPulseTopBar &&
    isFinishedOnBoarding &&
    isTeamLicense &&
    !_.isEmpty(teamPMEntitiesIds) &&
    !isAllControbutorsTeamSelected;

  return (
    <Page>
      <StyledBackground>
        {isGroup && !isShowTeamOfTeamsDashboard && (
          <Flex justify='center' items='center' width='100%' height='100%'>
            <NotConnectedState
              notConnectedImg={groupDashboardPlaceholderImg}
              title='Group dashboard - coming soon!'
              info='Meanwhile, select teams to view their dashboards.'
              afterButtonInfo=''
              image={computerDude}
            ></NotConnectedState>
          </Flex>
        )}
        {hasNoData && isTeamLicense && !isProcessingRepos ? (
          <NoDataDashboard />
        ) : (
          <Grid container>
            <Grid item xs={12}>
              <Margin>
                {isFinishedOnBoarding &&
                  organization &&
                  organization.license.plan_tier_type === 'trial' && (
                    <TrialBar
                      account={account}
                      organization={organization}
                      toggleModal={toggleModal}
                    />
                  )}
              </Margin>
            </Grid>
            {shouldShowPulseTopBar && (
              <PulseDashboardBar
                history={history}
                onClose={() => {
                  localStorageAccessor.set(
                    LOCAL_STORAGE_KEYS.CLOSED_PULSE_BAR,
                    true
                  );
                  setClosedPulseTopBar(true);
                }}
                latestIteration={latestIteration}
                goToPreviousIteration={() =>
                  DateSelectionChanged(current5Iterations[1])
                }
              />
            )}
            <Grid item xs={12}>
              {isGroup && isShowTeamOfTeamsDashboard && (
                <GroupDashboard
                  isSelectedTeamParent={isSelectedTeamParent}
                  toggleModal={toggleModal}
                  gitScopeToggle={gitScopeToggle}
                />
              )}
            </Grid>
            {isVPMode && (
              <AllTeamsDashboard
                selectedTeam={selectedTeam}
                activities={activities}
                metrics={metrics}
                cycleTimeGridSize={cycleTimeGridSize}
                workBreakdownTrendData={workBreakdownTrendData}
                teamWorkBreakdownData={teamWorkBreakdownData}
                cycleTimeTrendData={cycleTimeTrendData}
                cycleTimeAverage={cycleTimeAverage}
                totalCycleTimeInMinutes={totalCycleTimeInMinutes}
                pipelineMilestones={pipelineMilestones}
                orgWorkBreakdownData={orgWorkBreakdownData}
                shouldHidePersonalInformationDashboard={
                  shouldHidePersonalInformationDashboard
                }
                {...props}
              />
            )}

            {!isVPMode && !isGroup && isAllControbutorsTeamSelected && (
              <AllContributorsDoraDashboard
                isLodingCycleTimeData={isLodingCycleTimeData}
                cycleTimeTrendData={cycleTimeTrendData}
                cycleTimeAverage={cycleTimeAverage}
                totalCycleTimeInMinutes={totalCycleTimeInMinutes}
                pipelineMilestones={pipelineMilestones}
              />
            )}
            {!!(
              currentTeams.length &&
              selectedTeam &&
              !isAllControbutorsTeamSelected &&
              (isIterationsPeriodKeySelected
                ? !isRetrospect || isNewTeamDashboardPastIterationEnabled
                : true) && // If selected period - show TeamDashboardCurrentIteration view for Team
              !isGroup
            ) && (
              <TeamDashboardCurrentIterationNew
                handleOnSlackConnectClick={handleOnSlackConnectClick}
                workBreakdownTrendData={workBreakdownTrendData}
                teamWorkBreakdownData={teamWorkBreakdownData}
                cycleTimeTrendData={cycleTimeTrendData}
                cycleTimeAverage={cycleTimeAverage}
                totalCycleTimeInMinutes={totalCycleTimeInMinutes}
                pipelineMilestones={pipelineMilestones}
                notifications={notifications}
                teamSlackSettings={teamSlackSettings}
                onRemoveNotificationClick={onRemoveNotificationClick}
                contributorsOrder={contributorsOrder}
                contributorsMetrics={contributorsMetrics}
                setContributorsOrder={setContributorsOrder}
                isNotificationsLoading={isNotificationsLoading}
                slackSensorAuhorization={slackSensorAuhorization}
                isFinishedOnBoarding={isFinishedOnBoarding}
                issuesProps={issuesProps}
                isTeamPMConfigurationEnabled={isTeamPMConfigurationEnabled}
                isIterationsPeriodKeySelected={isIterationsPeriodKeySelected}
                toggleModal={toggleModal}
                current5Iterations={current5Iterations}
                isDefaultIterationTooLong={isDefaultIterationTooLong}
                gitScopeToggle={gitScopeToggle}
              />
            )}

            {!!(
              currentTeams.length &&
              selectedTeam &&
              !isAllControbutorsTeamSelected &&
              (isIterationsPeriodKeySelected
                ? isRetrospect && !isNewTeamDashboardPastIterationEnabled
                : false) && // If selected period - don't show this view
              !isGroup
            ) && (
              <TeamDashboardPreviousIteration
                {...props}
                cycleTimeGridSize={cycleTimeGridSize}
                workBreakdownTrendData={workBreakdownTrendData}
                teamWorkBreakdownData={teamWorkBreakdownData}
                cycleTimeTrendData={cycleTimeTrendData}
                cycleTimeAverage={cycleTimeAverage}
                totalCycleTimeInMinutes={totalCycleTimeInMinutes}
                pipelineMilestones={pipelineMilestones}
                orgWorkBreakdownData={orgWorkBreakdownData}
                teamRetrospectData={teamRetrospectData}
                deploymentFreqData={deploymentFreqData}
                noReleasesInIterations={noReleasesInIterations}
                contributorsOrder={contributorsOrder}
                setContributorsOrder={setContributorsOrder}
                teamMetrics={teamMetrics}
                contributorsMetrics={contributorsMetrics}
                reviewsTrendData={reviewsTrendData}
                shouldHidePersonalInformationDashboard={
                  shouldHidePersonalInformationDashboard
                }
              />
            )}
          </Grid>
        )}
      </StyledBackground>
    </Page>
  );
};

export default Dashboard;
